import api from './api';

export interface OnboardingStepStatus {
  id: 'company' | 'branch' | 'users';
  label: string;
  completed: boolean;
  count: number;
  required: number;
}

export interface OnboardingStatus {
  companyId: string;
  companyName: string;
  company?: {
    id: string;
    name: string;
    taxId: string;
    email: string;
    phone: string;
    website?: string | null;
    street: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };
  steps: OnboardingStepStatus[];
  allStepsComplete: boolean;
  isComplete: boolean;
  completedAt: string | null;
  currentStep: string;
}

const onboardingService = {
  async getStatus(): Promise<OnboardingStatus> {
    const { data } = await api.get<OnboardingStatus>('/onboarding/status');
    return data;
  },

  async complete(): Promise<{ completed: boolean; completedAt: string }> {
    const { data } = await api.post<{ completed: boolean; completedAt: string }>('/onboarding/complete');
    return data;
  },
};

export default onboardingService;
